module.exports = __webpack_public_path__ + "static/media/cov_can_arr.ae78dd0b.png";